
  <ng-container *ngIf="this.isMobile">
    <div class="modern-airport-dropdown" style="display: block !important;"
      (mousedown)="$event.preventDefault(); this.searchService.onSelectingFromDropdown = true;"
      (click)="$event.stopPropagation();">
      <hr>
      <div class="modern-airport-body">
        <div *ngFor="let item of this.autoCompleteSourceItems;let i=index" 
          class="airport-group tabindex{{i}}" tabindex="0" (keydown)="handleKeyDown($event,i)">
          
          <!-- Single airport item - show airplane icon -->
          <button *ngIf="item.airports.length===1" class="airport-item single-airport-item tabindex{{i}}" tabindex="0"
            (click)="$event.stopPropagation();selectAirport(item.airports[0])">
            <svg *ngIf="this.viewMode=='tab1'" class="airport-icon plane-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M20.5 19H3.5C2.95 19 2.5 19.45 2.5 20C2.5 20.55 2.95 21 3.5 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.64C21.85 8.84 21.03 8.37 20.23 8.58L14.92 10L8.46 3.98C8.19 3.72 7.8 3.63 7.44 3.73C6.76 3.92 6.44 4.7 6.79 5.31L10.23 11.27L5.26 12.6L3.69 11.36C3.44 11.17 3.12 11.1 2.81 11.18L2.48 11.27C2.16 11.35 2.01 11.72 2.18 12L4.06 15.25C4.29 15.64 4.75 15.83 5.18 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.64Z" fill="currentColor"/>
            </svg>
            <svg *ngIf="this.viewMode=='tab5'" class="airport-icon train-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="16" height="16" x="4" y="3" rx="2"></rect>
              <path d="M4 11h16"></path>
              <path d="M12 3v8"></path>
              <path d="m8 19-2 3"></path>
              <path d="m18 22-2-3"></path>
              <path d="M8 15h.01"></path>
              <path d="M16 15h.01"></path>
            </svg>
            <div class="airport-info">
              <p class="airport-name"><strong>{{item.airports[0].code}}</strong>, {{getAirportName(item.airports[0].airport, item.airports[0].code)}}</p>
              <p class="airport-location">
                <span *ngIf="this.viewMode == 'tab1'">{{'airport.Airportin' | translate }}</span>
                <span *ngIf="this.viewMode == 'tab5'">Station in</span>
                {{item.city}}
              </p>
            </div>
          </button>
          
          <!-- Grouped city item - show pin icon -->
          <div *ngIf="item.airports.length > 1" class="city-with-airports" id="multipleAirports{{i}}" [ngClass]="{'expanded': isGroupExpanded(i)}" (click)="$event.stopPropagation()">
            <button type="button" class="airport-item city-header tabindex{{i}}" tabindex="0"
              (click)="$event.stopPropagation(); $event.preventDefault(); toggleGroup(i, $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="airport-icon map-pin-icon">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <div class="airport-info">
                <p class="airport-name">{{item.city}}</p>
                <p class="airport-location">City in {{item.city}}, United States</p>
              </div>
              <svg class="chevron-icon" [ngClass]="{'rotated': isGroupExpanded(i)}" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m18 15-6-6-6 6"></path>
              </svg>
            </button>

            <div class="airports-list" *ngIf="isGroupExpanded(i)">
              <button *ngFor="let item1 of item.airports; let childindex=index"
                class="airport-item airport-subitem tabindex{{i}}_{{childindex}}" tabindex="0"
                (click)="$event.stopPropagation();selectAirport(item1)">
                <svg *ngIf="this.viewMode=='tab1'" class="airport-icon plane-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M20.5 19H3.5C2.95 19 2.5 19.45 2.5 20C2.5 20.55 2.95 21 3.5 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.64C21.85 8.84 21.03 8.37 20.23 8.58L14.92 10L8.46 3.98C8.19 3.72 7.8 3.63 7.44 3.73C6.76 3.92 6.44 4.7 6.79 5.31L10.23 11.27L5.26 12.6L3.69 11.36C3.44 11.17 3.12 11.1 2.81 11.18L2.48 11.27C2.16 11.35 2.01 11.72 2.18 12L4.06 15.25C4.29 15.64 4.75 15.83 5.18 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.64Z" fill="currentColor"/>
                </svg>
                <svg *ngIf="this.viewMode=='tab5'" class="airport-icon train-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="16" height="16" x="4" y="3" rx="2"></rect>
                  <path d="M4 11h16"></path>
                  <path d="M12 3v8"></path>
                  <path d="m8 19-2 3"></path>
                  <path d="m18 22-2-3"></path>
                  <path d="M8 15h.01"></path>
                  <path d="M16 15h.01"></path>
                </svg>
                <div class="airport-info">
                  <p class="airport-name"><strong>{{item1.code}}</strong>, {{getAirportName(item1.airport, item1.code)}}</p>
                  <p style="display:none;" class="airport-location">{{item1.distance || '0'}} miles away from city center</p>
                </div>
              </button>
            </div>
          </div>
        </div>
        
        <div *ngIf="this.autoCompleteSourceItems.length===0 && this.searchString.length > 0" class="no-results">
          {{'airport.Nomatchinglocationsfound' | translate }}
        </div>
      </div>
    </div>
  </ng-container>


  
  <ng-container *ngIf="!this.isMobile">
    <div class="modern-airport-dropdown" style="display: block !important;"
      (mousedown)="$event.preventDefault(); this.searchService.onSelectingFromDropdown = true;"
      (click)="$event.stopPropagation();">
      <div class="modern-airport-body">
        <div *ngFor="let item of this.autoCompleteSourceItems;let i=index" 
          class="airport-group tabindex{{i}}" tabindex="0" (keydown)="handleKeyDown($event,i)">
          
          <!-- Single airport item - show airplane icon -->
          <button *ngIf="item.airports.length===1" class="airport-item single-airport-item tabindex{{i}}" tabindex="0"
            (click)="this.searchService.sourceAirportInputValue='';selectAirport(item.airports[0])">
            <svg *ngIf="this.viewMode=='tab1'" class="airport-icon plane-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M20.5 19H3.5C2.95 19 2.5 19.45 2.5 20C2.5 20.55 2.95 21 3.5 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.64C21.85 8.84 21.03 8.37 20.23 8.58L14.92 10L8.46 3.98C8.19 3.72 7.8 3.63 7.44 3.73C6.76 3.92 6.44 4.7 6.79 5.31L10.23 11.27L5.26 12.6L3.69 11.36C3.44 11.17 3.12 11.1 2.81 11.18L2.48 11.27C2.16 11.35 2.01 11.72 2.18 12L4.06 15.25C4.29 15.64 4.75 15.83 5.18 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.64Z" fill="currentColor"/>
            </svg>
            <svg *ngIf="this.viewMode=='tab5'" class="airport-icon train-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="16" height="16" x="4" y="3" rx="2"></rect>
              <path d="M4 11h16"></path>
              <path d="M12 3v8"></path>
              <path d="m8 19-2 3"></path>
              <path d="m18 22-2-3"></path>
              <path d="M8 15h.01"></path>
              <path d="M16 15h.01"></path>
            </svg>
            <div class="airport-info">
              <p class="airport-name"><strong>{{item.airports[0].code}}</strong>, {{getAirportName(item.airports[0].airport, item.airports[0].code)}}</p>
              <p class="airport-location">
                <span *ngIf="this.viewMode == 'tab1'">{{'airport.Airportin' | translate }}</span>
                <span *ngIf="this.viewMode == 'tab5'">Station in</span>
                {{item.city}}
              </p>
            </div>
          </button>

          <!-- Grouped city item - show pin icon -->
          <div *ngIf="item.airports.length > 1" class="city-with-airports" id="multipleAirports{{i}}" [ngClass]="{'expanded': isGroupExpanded(i)}" (click)="$event.stopPropagation()">
            <button type="button" class="airport-item city-header tabindex{{i}}" tabindex="0"
              (click)="$event.stopPropagation(); $event.preventDefault(); toggleGroup(i, $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="airport-icon map-pin-icon">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <div class="airport-info">
                <p class="airport-name">{{item.city}}</p>
                <p class="airport-location">City in {{item.city}}, United States</p>
              </div>
              <svg class="chevron-icon" [ngClass]="{'rotated': isGroupExpanded(i)}" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m18 15-6-6-6 6"></path>
              </svg>
            </button>

            <div class="airports-list" *ngIf="isGroupExpanded(i)">
              <button *ngFor="let item1 of item.airports; let childindex=index"
                class="airport-item airport-subitem tabindex{{i}}_{{childindex}}" tabindex="0"
                (click)="this.searchService.sourceAirportInputValue='';selectAirport(item1)">
                <svg *ngIf="this.viewMode=='tab1'" class="airport-icon plane-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M20.5 19H3.5C2.95 19 2.5 19.45 2.5 20C2.5 20.55 2.95 21 3.5 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.64C21.85 8.84 21.03 8.37 20.23 8.58L14.92 10L8.46 3.98C8.19 3.72 7.8 3.63 7.44 3.73C6.76 3.92 6.44 4.7 6.79 5.31L10.23 11.27L5.26 12.6L3.69 11.36C3.44 11.17 3.12 11.1 2.81 11.18L2.48 11.27C2.16 11.35 2.01 11.72 2.18 12L4.06 15.25C4.29 15.64 4.75 15.83 5.18 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.64Z" fill="currentColor"/>
                </svg>
                <svg *ngIf="this.viewMode=='tab5'" class="airport-icon train-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="16" height="16" x="4" y="3" rx="2"></rect>
                  <path d="M4 11h16"></path>
                  <path d="M12 3v8"></path>
                  <path d="m8 19-2 3"></path>
                  <path d="m18 22-2-3"></path>
                  <path d="M8 15h.01"></path>
                  <path d="M16 15h.01"></path>
                </svg>
                <div class="airport-info">
                  <p class="airport-name"><strong>{{item1.code}}</strong>, {{getAirportName(item1.airport, item1.code)}}</p>
                  <p style="display:none;" class="airport-location">{{item1.distance || '0'}} miles away from city center</p>
                </div>
              </button>
            </div>
          </div>
        </div>
        
        <div *ngIf="this.autoCompleteSourceItems.length===0 && this.searchString.length > 0" class="no-results">
          {{'airport.Nomatchinglocationsfound' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
